
<mat-card sm-restrict-width sm-center>
    <mat-card-title>{{ 'WAITLIST.TITLE' | translate }}</mat-card-title>

  <mat-card-content>
    <div>
      <label for="clientNotes">{{ 'WAITLIST.NOTES_LABEL' | translate }}</label>
      <br/>
    <mat-list *ngIf='booking.getServices().length > 0'>
      <h3>{{ 'WAITLIST.SERVICES_REQUESTED' | translate }}</h3>
      <mat-list-item *ngFor="let service of booking.getServices()">
        <span mat-line>
          {{ service.getName() }} with {{ service.getStylist().getFirstName() }} {{ service.getStylist().getLastName() }}
        </span>
        <p mat-line>
          <span *ngIf="service.getServiceDefinition().getStartingAt() == 1 && service.getStylist().getHidePrices() !== 1">{{ 'BOOKINGS.STARTING_AT' | translate }}</span>
          {{ service.getStylist().getHidePrices() !== 1 ? (service.getServiceDefinition().getPrice() | salonMonsterCurrency) + ", " : '' }}
          <span *ngIf="service.getStylist().getHideDurations() !== 1">{{ 'BOOKINGS.ABOUT' | translate }} {{ service.getDurations().startDuration + service.getDurations().processDuration + service.getDurations().finishDuration | SalonMonsterFormatDurationPipe }}</span>
        </p>
      </mat-list-item>
    </mat-list>      
    <h3>{{ 'WAITLIST.DESIRED_TIMEFRAME' | translate }}</h3>
    <br />
      <textarea 
        matInput 
        name="clientNotes" 
        rows="4" cols="50"
        [(ngModel)]="clientNotes"
        [placeholder]="'WAITLIST.TIMEFRAME_EXAMPLE' | translate"
        class="sm-waitlist-details"></textarea>
    </div>    
  </mat-card-content>
</mat-card>
<div>
  <salonmonster-stripe-payment *ngIf="clientBookingPayments" (onBookingSave)="onBookingSave()" mode="waitlist" [refreshStripe]="refreshStripe" [booking]="booking"></salonmonster-stripe-payment>
</div>
<mat-card sm-restrict-width sm-center *ngIf="!clientBookingPayments || !this.userService.isLoggedIn()">
  <mat-card-actions>
    <button
      mat-raised-button
      class='smc-button-large smc-button-primary'
      (click)="onBookingSave()"
      >
      <ng-container *ngIf="this.userService.isLoggedIn()">{{ 'WAITLIST.ADD_ME' | translate }}</ng-container>
      <ng-container *ngIf="!this.userService.isLoggedIn()">{{ 'WAITLIST.LOG_IN_TO_CONTINUE' | translate }}</ng-container>
    </button>
  </mat-card-actions>
  <br /><br />
</mat-card>


